let mapDot = {

	北海: [109.12, 21.49],
	灵山县: [109.29, 22.41],
	玉林: [110.18, 22.65],
	横州: [109.27, 22.69],
	西乡塘: [108.20, 22.70],
	南宁: [108.33, 22.84],
	崇左: [107.22, 22.88],
	凭祥: [106.71, 22.88],
	平果: [107.58, 23.32],
	隆安: [107.22, 23.55],
	百色: [106.62, 23.90],
	凤山: [107.02, 24.32],
	河池: [108.22, 24.88],
	马山: [108.71, 23.88],
	桂林: [110.28, 25.29],
	钦州: [108.62, 21.95],
};

export default mapDot
